var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArrowIconSvg_svg__clip0_5_809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.606l7.75 7.366-7.578 7.476L1.822 18l9.177-9.084L1.595 0 0 1.606z",
    fill: "#4F5260"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ArrowIconSvg_svg__clip0_5_809"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 9 9)",
    d: "M0 0h18v11H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzVfODA5KSI+CjxwYXRoIGQ9Ik0tNy4xNjU1NWUtMDcgMS42MDYxN0w3Ljc1MDkxIDguOTcxOTlMMC4xNzE4NzUgMTYuNDQ4NEwxLjgyMTg5IDE3Ljk5OUwxMC45OTg3IDguOTE1NDVMMS41OTUwNSAtMC4wMDA5NzY2MzJMLTcuMTY1NTVlLTA3IDEuNjA2MTdaIiBmaWxsPSIjNEY1MjYwIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNV84MDkiPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTEiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDE4KSByb3RhdGUoLTkwKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgArrowIconSvg as ReactComponent };